module.exports = __webpack_public_path__ + "static/media/bell.06c64f68.svg";